<h3>Help & Support</h3>
<hr>
<ng-container *ngIf="util.getTokenData(); else default">
  <form [formGroup]="supportForm">
    <div class="row">
      <app-input-field class="col-md-12" [control]="supportForm.get('name')" label="Name" placeholder="Enter your Name">
      </app-input-field>
      <app-input-field class="col-md-6" [control]="supportForm.get('mobile')" label="Mobile"
        placeholder="Enter your  Contact Number">
      </app-input-field>
      <app-input-field class="col-md-6" [control]="supportForm.get('email')" label="Email"
        placeholder="Enter your your Email">
      </app-input-field>
      <app-input-field class="col-md-12" [control]="supportForm.get('query')" label="Query"
        placeholder="Enter your query...">
      </app-input-field>
      <app-textarea-field class="col-md-12" [control]="supportForm.get('detail')" label="Detail"
        placeholder="Enter your query details...">
      </app-textarea-field>
    </div>
    <div class="mat-form-field upload-photo">
      <div class="file-upload w-100">
        <label for="doc">Upload Attachment</label>
        <input type="file" accept="image/*" (change)="onSelectedFile($event)" />
      </div>
    </div>
    <button class="w-100 mt-3" mat-flat-button type="submit" color="primary" (click)="submit()">Submit</button>
  </form>
  <hr>
  <p> For more help contact us at below contact details (between <strong>10AM to 6PM</strong>):</p>
</ng-container>
<ng-template #default>
  <p> Get in touch with us for any help and query using the below <br> contact details
    (between <strong>10AM to 6PM</strong>):
  </p>
</ng-template>
<h6 class="text-center m-0"><strong>MIS Support</strong></h6>
<div class="contacts">
  <a mat-stroked-button href="tel:+918800406449">
    <mat-icon>call</mat-icon>
    +91 8800406449
  </a>

  <!-- INFO Removed as per instructed by Imran Sir wrt CCSWAP-141 -->
  <!-- <a mat-stroked-button href="tel:01140747141">
    <mat-icon>call</mat-icon>
    011 40747141
  </a> -->

  <a mat-stroked-button href="mailto:support@sbmurban.org">
    <mat-icon>email</mat-icon>
    support@sbmurban.org
  </a>
</div>
<!-- <hr> -->
<!-- <h6 class="text-center m-0"><strong>GFC Support</strong></h6>
<div class="contacts mt-2">
  <!-- <a mat-stroked-button href="tel:+919654796676">
    <mat-icon>call</mat-icon>
    +91 9654796676
  </a> -->
  <!-- <a mat-stroked-button href="mailto:gfc@sbmurban.org">
    <mat-icon>email</mat-icon>
    gfc@sbmurban.org
  </a>
</div> -->
